import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'técnicos y estudiantes ya accedieron',
  color: 'text-navy'
}, {
  value: '25',
  label: 'Manuales maestros',
  color: 'text-navy'
}, {
  value: '4.9/5',
  label: 'calificación',
  hasStar: true,
  color: 'text-electric'
}, {
  value: '🌎',
  label: 'Edición LATAM',
  color: 'text-navy'
}];
const testimonials = [{
  initials: 'AM',
  name: 'Andrés M.',
  location: 'Ciudad de México',
  specialty: 'Electricidad Residencial',
  quote: '"Me ayudó a organizar mejor mis presupuestos"',
  color: 'bg-navy'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  location: 'Bogotá, Colombia',
  specialty: 'Electricidad Industrial',
  quote: '"Los diagramas son claros y fáciles de consultar"',
  color: 'bg-navy'
}, {
  initials: 'LT',
  name: 'Luis T.',
  location: 'Lima, Perú',
  specialty: 'Técnico Electricista',
  quote: '"Me sirvió para repasar conceptos y trabajar con más seguridad"',
  color: 'bg-navy'
}];
export function SocialProof() {
  return <section className="py-8 md:py-16 px-4 max-w-7xl mx-auto relative z-10" data-id="element-271">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-272">
        {stats.map((stat, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-4 md:p-6 rounded border border-slate-200 text-center shadow-sm hover:shadow-md transition-shadow" data-id="element-273">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-274">
              <span className={`text-3xl md:text-5xl font-black ${stat.color}`} data-id="element-275">
                {stat.value}
              </span>
              {stat.hasStar && <Star className="fill-electric text-electric w-5 h-5 md:w-8 md:h-8" data-id="element-276" />}
            </div>
            <p className="text-slate-600 font-bold text-[11px] md:text-sm uppercase tracking-wider" data-id="element-277">
              {stat.label}
            </p>
          </motion.div>)}
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-278">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1 + 0.2
      }} className="bg-white p-6 md:p-8 rounded shadow-lg border-t-4 border-electric relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-279">
            <div className="flex items-center gap-4 mb-6" data-id="element-280">
              <div className={`${t.color} w-12 h-12 md:w-14 md:h-14 rounded flex items-center justify-center text-electric font-black text-lg md:text-xl shadow-inner`} data-id="element-281">
                {t.initials}
              </div>
              <div data-id="element-282">
                <div className="flex gap-1 mb-1" data-id="element-283">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-electric text-electric" data-id="element-284" />)}
                </div>
                <p className="text-[10px] font-bold text-navy uppercase tracking-widest bg-slate-100 border border-slate-200 inline-block px-2 py-0.5 rounded" data-id="element-285">
                  Verificado
                </p>
              </div>
            </div>
            <blockquote className="text-lg md:text-xl font-bold text-slate-800 mb-6 leading-snug" data-id="element-286">
              {t.quote}
            </blockquote>
            <div className="flex items-center justify-between pt-6 border-t border-slate-100" data-id="element-287">
              <div data-id="element-288">
                <p className="font-black text-navy text-sm md:text-base" data-id="element-289">
                  {t.name}
                </p>
                <div className="flex items-center gap-1 text-slate-500 font-semibold text-xs mt-1" data-id="element-290">
                  <MapPin size={14} className="text-slate-400" data-id="element-291" />
                  <span data-id="element-292">
                    {t.location} | {t.specialty}
                  </span>
                </div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}